var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('onboarding-flow',{attrs:{"step-id":_vm.stepId,"data":_vm.data},on:{"update-data":_vm.onUpdateData,"change-step":_vm.onChangeStep}})
}
var staticRenderFns = []

export { render, staticRenderFns }